
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-us/efectos-secundarios",
      function () {
        return require("private-next-pages/es-us/efectos-secundarios.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-us/efectos-secundarios"])
      });
    }
  